import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimInvoice.Delete.IRequest;
type Response = Api.Core.ClaimInvoice.Delete.IResponse;
type Headers = Api.Core.ClaimInvoice.Delete.IHeaders;
const url = '/api/Claims/Claim/:id/Invoices/:invoiceId';
export default async function claimInvoiceDeleteApi(params: {
  id: number;
  invoiceId: number;
}): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
